import React from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FormattedMessage } from 'react-intl';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';

const LocalizedDescriptionField = ({ locale, object, showNote, ...props }) => {
  const propertyName = `description${locale.substring(0, 2)?.toUpperCase() ||
    ''}`;

  return (
    <AvGroup className="form-label-group">
      <FormattedMessage id={propertyName}>
        {(placeholder) => (
          <AvInput
            data-testid="input-form-description"
            id={object?.id || propertyName}
            type="textarea"
            rows="3"
            className="bg-transparent font-small-3 line-height-15"
            name={propertyName}
            placeholder={placeholder}
            value={object ? object[propertyName] : ''}
            {...props}
          />
        )}
      </FormattedMessage>
      <Label for={object?.id || propertyName}>
        <FormattedMessage id={propertyName} />
      </Label>
      {showNote && (
        <>
          <span
            style={{
              padding: '0.25rem 0',
              color: 'var(--primary)',
              fontSize: '0.7rem',
              marginLeft: '3px',
            }}
          >
            <FormattedMessage id="Du kannst die folgenden HTML Tags verwenden: <br>, <i>, <u>, <p> und <b>" />
          </span>
          <hr />
        </>
      )}
    </AvGroup>
  );
};

LocalizedDescriptionField.propTypes = {
  locale: PropTypes.string,
  object: PropTypes.object,
};

export default LocalizedDescriptionField;
